<template>
  <div class="activities">
    <div class="title">Campaigns</div>
    <a-tabs
      v-if="
        $store.state.link.allActivitiesList &&
          $store.state.link.allActivitiesList.length
      "
    >
      <a-tab-pane
        v-for="item in $store.state.link.allActivitiesList"
        :key="item.activityId"
      >
        <template #tab>
          <a-tooltip
            placement="topLeft"
            :title="item.name"
            :arrowPointAtCenter="false"
          >
            {{ item.name }}
          </a-tooltip>
        </template>
        <ActivitiesTable :tableData="item.refList"></ActivitiesTable>
      </a-tab-pane>
      <template #tabBarExtraContent>
        <a-button type="link" @click="$router.push({ path: 'links' })">
          MORE >>
        </a-button>
      </template>
    </a-tabs>
    <div v-else class="none-activity-tip">
      You have no activity,
      <router-link to="/links">click here to create one</router-link>
    </div>
  </div>
</template>

<script>
import ActivitiesTable from '@/components/ActivitiesTable'

export default {
  name: 'Activities',
  components: { ActivitiesTable },
}
</script>

<style lang="scss" scoped>
.activities {
  padding: 20px;
  background-color: #fff;
  text-align: left;
  border-radius: 4px;

  .title {
    font-size: 20px;
  }

  .header {
    display: flex;
    justify-content: space-between;
  }

  .none-activity-tip {
    width: 100%;
    text-align: center;
    font-size: 18px;
    margin: 20px;
  }
}
</style>

<style lang="scss">
.ant-tabs-tab {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ant-tabs-tab-prev.ant-tabs-tab-arrow-show,
.ant-tabs-tab-next.ant-tabs-tab-arrow-show {
  height: 90%;
}
</style>
